import React, { ReactNode } from 'react'
import { get, intersectionBy } from 'lodash'
import XLSX from 'xlsx/dist/xlsx.mini.min'

export interface ExportButtonProps {
    headers: string[]
    mappedFields: string[]
    exportedData: Record<string, string>[]
    filename?: string
    children?: ReactNode
    selectedIds?: number[]
}

const ExportButton = ({
    mappedFields,
    headers,
    exportedData,
    filename = 'export_data',
    children,
    selectedIds=[], // For exporting the selected row (multi select checkbox)
}: ExportButtonProps) => {
    const convertedSelectedIds = selectedIds.map((e) => ({ id: e }))

    const handleExportData = () => {
        let _exportedData = { ...exportedData }
        if (convertedSelectedIds.length) {
            _exportedData = intersectionBy(exportedData, convertedSelectedIds, 'id')
        }
        const convertedData = _exportedData.map((e) => (
            mappedFields.map((field) => get(e, field))
        ))
        /* convert state to workbook */
        const ws = XLSX.utils.aoa_to_sheet([headers, ...convertedData])
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
        /* generate XLSX file and send to client */
        XLSX.writeFile(wb, `${filename}.csv`)
    }
    return (
        <div onClick={handleExportData}>
            {children}
        </div>
    )
}

export default ExportButton
